import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const SupportMessagesModule = lazy(loadModule);

export default SupportMessagesModule;
